import i18n from '../i18n';
import { translateDynamic } from '../i18n/dynamic';

// Recent-activity items are built from server data with English titles/details, and the dashboards
// group them by those English titles. So the text is translated only when it is DISPLAYED.
const INVOICE = /^Invoice #(\S+)(?: for (.+?))?(?: paid by (.+?)| — (.+?))?$/;
const BOOKING = /^(.+?) — (.+?)(?: — (\$[\d.,]+))?$/;

export function localizeActivityTitle(title: string): string {
  return translateDynamic(title);
}

export function localizeActivityDetail(detail: string): string {
  if (!detail || (i18n.language || 'en').startsWith('en')) return detail;
  const inv = INVOICE.exec(detail);
  if (inv) {
    const [, num, amount, paidBy, client] = inv;
    const parts = [i18n.t('activity.invoiceNum', { num })];
    if (amount) parts.push(i18n.t('activity.forAmount', { amount }));
    if (paidBy) parts.push(i18n.t('activity.paidBy', { name: paidBy }));
    if (client) parts.push(`— ${client}`);
    return parts.join(' ');
  }
  const bk = BOOKING.exec(detail);
  if (bk) {
    const [, name, service, price] = bk;
    return `${name} — ${translateDynamic(service)}${price ? ` — ${price}` : ''}`;
  }
  return detail;
}

// shared/src builds these strings in English ("5h ago"); translate them only for display
export function localizeActivityTime(time: string): string {
  if (!time || (i18n.language || 'en').startsWith('en')) return time;
  if (time === 'Just now') return i18n.t('pages.dashboard.DashboardOwners.justNow');
  if (time === 'Yesterday') return i18n.t('pages.dashboard.DashboardOwners.yesterday');
  const m = /^(\d+)([mhd]) ago$/.exec(time);
  if (m) return i18n.t(m[2] === 'm' ? 'activity.minutesAgo' : m[2] === 'h' ? 'activity.hoursAgo' : 'activity.daysAgo', { n: m[1] });
  return time;
}

export function localizeActivity<T extends { title: string; detail: string; time?: string }>(a: T): T {
  return { ...a, title: localizeActivityTitle(a.title), detail: localizeActivityDetail(a.detail), time: a.time === undefined ? a.time : localizeActivityTime(a.time) } as T;
}
